{
  "pages": {
    "leads": {
      "title": "Prospects"
    },
    "deals": {
      "title": "Affaires"
    },
    "tasks": {
      "title": "Tâches"
    },
    "followups": {
      "title": "Followups",
      "description": "Calls, meetings, reminders et next actions"
    },
    "campaigns": {
      "title": "Campagnes CRM"
    },
    "contacts": {
      "title": "Contacts"
    },
    "companies": {
      "title": "Sociétés"
    },
    "reports": {
      "title": "Rapports CRM"
    },
    "setup": {
      "title": "Configuration CRM"
    },
    "customers": {
      "title": "Client 360",
      "description": "Client 360 — chronologie Fattah unifiée",
      "loading": "Chargement du profil client…"
    },
    "dashboard": {
      "title": "Tableau de bord CRM",
      "description": "Pipeline, prospects et revenus — filtrés selon votre périmètre de visibilité",
      "pipelineDetails": "Détails du pipeline",
      "openDeals": "Affaires ouvertes",
      "forecastRevenue": "Revenus prévisionnels",
      "wonRevenue": "Revenus gagnés",
      "conversionRate": "Taux de conversion",
      "activitiesDue": "Activités à faire",
      "totalLeads": "Total prospects"
    },
    "segmentedOutreachWithEmailSmsAnd": "Segmented outreach avec email, SMS, et WhatsApp channels",
    "b2bAccountsWithContactsDealsAnd": "B2B accounts avec contacts, deals, et activities",
    "organizationWideCustomerContactsLinkedTo": "Organization-wide client contacts linked à Client 360",
    "pipelineKanbanAndDealListWith": "Pipeline kanban et deal list avec finance quote integration",
    "createLead": "Create lead",
    "manageLeadIntakeQualificationAndConversion": "Manage lead intake, qualification et conversion",
    "noLeadsYet": "No leads yet",
    "captureLeadsFromCampaignsOrAdd": "Capture leads de campaigns ou ajouter them manually à start votre pipeline.",
    "pipelineConversionLeadSourceAndSalesperson": "Pipeline, conversion, lead source, et salesperson performance",
    "pipelines": "Pipelines",
    "scoringRules": "Scoring rules",
    "assignmentRules": "Assignment rules",
    "workflowAutomations": "Flux de travail automations",
    "emailAccountsImapSync": "Email accounts (IMAP sync)",
    "pipelinesScoringAssignmentWorkflowsLeadSources": "Pipelines, scoring, assignment, flux de travails, lead sources, territories, email sync",
    "openCrmTasksAndFollowUps": "Open CRM tasks et follow-ups pour votre team"
  },
  "toast": {
    "leadCreated": "Prospect créé",
    "leadConverted": "Prospect converti — affaire créée",
    "campaignCreated": "Campagne créée",
    "campaignLaunched": "Campagne lancée",
    "campaignScheduled": "Campagne planifiée",
    "taskCreated": "Tâche créée",
    "taskCompleted": "Tâche terminée",
    "quoteCreated": "Devis créé (facture n°{{invoiceId}})",
    "emailSynced": "{{count}} nouvelles activités e-mail synchronisées",
    "gmailConnected": "Gmail connecté via XOAUTH2 : {{email}}"
  },
  "errors": {
    "leadCreationFailed": "Échec de la création du prospect",
    "leadConversionFailed": "Échec de la conversion du prospect",
    "loadPipelineFailed": "Échec du chargement du pipeline",
    "moveDealFailed": "Échec du déplacement de l'affaire",
    "createQuoteFailed": "Échec de la création du devis",
    "loadCustomer360Failed": "Échec du chargement du Client 360",
    "createCampaignFailed": "Échec de la création de la campagne",
    "launchFailed": "Échec du lancement",
    "scheduleDateRequired": "Choisissez d'abord une date/heure de planification",
    "scheduleFailed": "Échec de la planification",
    "createFailed": "Échec de la création",
    "reportsUnavailable": "Rapports indisponibles",
    "loadSetupFailed": "Échec du chargement de la configuration",
    "connectEmailFailed": "Échec de la connexion du compte e-mail",
    "emailSyncFailed": "Échec de la synchronisation e-mail",
    "setupFailed": "Échec de la configuration",
    "googleOAuthNotConfigured": "Google OAuth non configuré",
    "loadTasksFailed": "Échec du chargement des tâches",
    "createTaskFailed": "Échec de la création de la tâche",
    "completeTaskFailed": "Échec de la finalisation de la tâche",
    "googleOAuthFailed": "Échec Google OAuth : {{error}}",
    "oauthConnectFailed": "Échec de la connexion OAuth",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToLoadCompanies": "Échec du chargement de companies",
    "failedToLoadContacts": "Échec du chargement de contacts",
    "failedToLoadDeals": "Échec du chargement de deals",
    "failedToLoadCrmLeads": "Échec du chargement de cRM leads"
  },
  "oauth": {
    "connecting": "Connexion du compte Gmail…"
  },
  "labels": {
    "campaignName": "Campaign name",
    "channel": "Channel",
    "audienceSegment": "Audience segment",
    "scheduleTimeForRowActionsBelow": "Schedule time (for row actions below)",
    "searchContacts": "Search contacts",
    "searchNameOrEmail": "Search name ou email",
    "leadSource": "Lead source",
    "leadStatus": "Lead status",
    "leadScore": "Lead score",
    "dealName": "Deal name",
    "expectedRevenue": "Expected revenue",
    "customerName": "Client name",
    "customerEmail": "Client email",
    "email": "Email",
    "imapHost": "IMAP host",
    "imapPort": "IMAP port",
    "imapUsername": "IMAP utiliserrname",
    "imapPassword": "IMAP password",
    "imapPort993": "IMAP port (993)",
    "newTask": "New task"
  },
  "formActions": {
    "convertToDeal": "Convertir en affaire",
    "createCampaign": "Créer une campagne"
  },
  "listActions": {
    "newLead": "Nouveau prospect"
  }
}
